import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Link } from '../link/Link';

const ItemWrapper = styled.span`
  display: flex;
  align-items: center;
  font-size: ${themeGet('breadcrumb.text.fontSize')};
  line-height: 1.5;
  color: ${themeGet('breadcrumb.text.color')};
`;

const BreadcrumbLink = styled(Link)`
  font-size: ${themeGet('breadcrumb.link.fontSize')};
  color: ${themeGet('breadcrumb.link.color')};
  text-decoration: none;

  &:hover {
    color: ${themeGet('breadcrumb.link.hover.color')};
  }

  &:active {
    color: ${themeGet('breadcrumb.link.active.color')};
  }
`;

const Text = styled.span`
  color: ${themeGet('breadcrumb.text.current.color')};
`;

const Separator = styled.span`
  margin: 0 4px;
`;

const BreadcrumbItem = ({ separator = '/', href, current, linkProps, children, ...rest }) => {
  let link = null;
  if (current) {
    link = <Text>{children}</Text>;
  } else {
    link = (
      <BreadcrumbLink target="_self" href={href} {...linkProps}>
        {children}
      </BreadcrumbLink>
    );
  }

  return (
    <ItemWrapper {...rest}>
      {link}
      {!current && <Separator>{separator}</Separator>}
    </ItemWrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Breadcrumb = ({ separator, children, ...rest }) => {
  let crumbs = null;

  if (children) {
    crumbs = React.Children.map(children, (child, index) => {
      return React.cloneElement(child, {
        current: index === children.length - 1,
        separator,
      });
    });
  }

  return <Wrapper {...rest}>{crumbs}</Wrapper>;
};

Breadcrumb.Item = BreadcrumbItem;

Breadcrumb.defaultProps = {
  separator: '/',
};
